<template>
  <v-card>
    <v-toolbar
      dark
      color="primary"
    >
      <v-toolbar-title class="text-no-wrap">{{currentQuestion.heading}}</v-toolbar-title>
    </v-toolbar>
    <blockquote class="blockquote">{{currentQuestion.body}}</blockquote>
    <v-container
      fluid
      grid-list-lg
    >
      <v-layout
        row
        wrap
      >
        <v-flex
          xs12
          v-for="segment in currentQuestion.segments"
          v-bind:key="segment.questionSegmentId"
        >
          <v-card class="elevation-12">
            <v-card-title primary-title>
              <div>
                <span>({{segment.pointsValue}} pts) - {{segment.text}}</span>
              </div>
            </v-card-title>
            <v-card-text>
              <div
                v-show="awaitingAnswers"
                :full-width="true"
              >
                <v-text-field
                  prepend-icon="subdirectory_arrow_right"
                  v-model="segment.answers"
                  label="Answer"
                  outline
                ></v-text-field>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <div class="ma-6">

      <v-btn
        block
        color="success"
        dark
        @click="confirmAnswers = true"
        v-show="awaitingAnswers && !confirmAnswers"
      >Confirm Answers</v-btn>
      <div v-show="awaitingAnswers && confirmAnswers">
        <p class="warning--text title text-xs-center">Last chance to confirm answers!</p>
        <v-btn
        block
        color="warning"
        dark
        @click="submitAnswers"
      >Lock them in, Submit!</v-btn>
      </div>
    </div>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
import GameModel from "../../api/game-model";

export default {
  name: "Question",
  data() {
    return {
      gameStates: GameModel.GameClientState,
      confirmAnswers: false
    };
  },
  methods: {
    submitAnswers() {
      this.confirmAnswers = false;

      this.$store
        .dispatch("client/submitAnswers", this.currentQuestion)
        .catch(e => alert("Bummer, we failed to submit your answers... " + e.message));
    }
  },
  computed: {
    ...mapState("client", {
      // TODO: This fails strict validation. Notice I'm using v-model on the answers. This causes bidirectional mutations outside of a commit.
      // I should fix this at some point... maybe
      currentQuestion: state => state.game.currentQuestion,
      gameClientState: state => state.game.gameClientState
    }),
    awaitingAnswers() {
      return this.gameClientState === this.gameStates.AWAITING_TEAM_ANSWERS;
    }
  }
};
</script>